export default __webpack_public_path__ + "static/media/MobileImageItemEn3.184eee09.png";